import React from 'react';
import Grid from '@mui/material/Grid';

function Container(props) {
    return <Grid {...props} container>{props.children}</Grid>;
}

export default Container;
